@if (openItemsDataService.hasData()) {
  <router-outlet></router-outlet>
}
@else {
  <div>
    <div class="header-skeleton">
      <p-skeleton height="2.5rem"
                  width="4rem"
                  border-radius="4px"></p-skeleton>
      <p-skeleton height="2.5rem"
                  width="10rem"
                  border-radius="4px"></p-skeleton>
      <p-skeleton height="2.5rem"
                  width="4rem"
                  border-radius="4px"></p-skeleton>
    </div>
    <div class="body-skeleton">
      <p-skeleton width="100%"
                  height="33px"
                  border-radius="4px"></p-skeleton>
      <p-skeleton class="header-skeleton"
                  width="100px"
                  height="20px"
                  border-radius="4px"></p-skeleton>
      <p-skeleton class="area-skeleton"
                  width="100%"
                  height="76.5px"
                  border-radius="4px"></p-skeleton>
      <p-skeleton class="area-skeleton"
                  width="100%"
                  height="76.5px"
                  border-radius="4px"></p-skeleton>
      <p-skeleton class="area-skeleton"
                  width="100%"
                  height="76.5px"
                  border-radius="4px"></p-skeleton>
      <p-skeleton class="area-skeleton"
                  width="100%"
                  height="76.5px"
                  border-radius="4px"></p-skeleton>
      <p-skeleton class="area-skeleton"
                  width="100%"
                  height="76.5px"
                  border-radius="4px"></p-skeleton>
    </div>
  </div>
}